import { createFeature, createReducer, on } from '@ngrx/store';
import { exchangeRatesActions } from './exchange-rates.actions';

export interface ExchangeRatesState {
  lee: number | undefined;
  cheelee: number | undefined;
}

export const initialState: ExchangeRatesState = {
  lee: undefined,
  cheelee: undefined,
};

export const exchangeRatesFeature = createFeature({
  name: 'exchange-rates',
  reducer: createReducer(
    initialState,

    on(exchangeRatesActions.getCurrencyPairsSuccess,
      (state, { lee, cheelee }): ExchangeRatesState => ({
        ...state,
        lee,
        cheelee,
      }),
    ),
  ),
});
